import React from 'react';
import 'twin.macro';
import { useClassroomsTrash } from '@teetsh/app/src/containers/UserSettings/Trash/Classrooms/useClassroomsTrash';
import { useRestoreClassroom } from '@teetsh/app/src/containers/UserSettings/Trash/Classrooms/useRestoreClassroom';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableClassroom } from '@teetsh/app/src/types/classroom';

export function ClassroomsRestorableList() {
  const { data = [] } = useClassroomsTrash();
  const restore = useRestoreClassroom();

  return <RestorableList<RestorableClassroom> items={data} restore={restore} />;
}
